import React from 'react';
import styles from './StoreBadge.module.css';

export default function StoreBadge({ store }) {
  if (!store) return <span>—</span>;
  return (
    <span
      className={styles.badge}
      style={{ color: store.color, background: store.bg, borderColor: store.color + '55' }}
    >
      {store.name}
    </span>
  );
}
